import React from 'react';
import PropTypes from 'prop-types';

const LinkComponent = ({ to }) => (
  <a href={to} className="btn btn-xs btn-default">
    <span className="sr-only">Link</span>
    <i className="fas fa-arrow-right" />
  </a>
);

LinkComponent.propTypes = {
  to: PropTypes.string,
};

export const LinkRoute = ({ component: Component, to, ...props }) => {
  if (!to) {
    return null;
  }

  const prepareTo = to.replace('/admin', '');
  if ((to.includes('services') || to.includes('orders')) && Component) {
    return <Component to={prepareTo} {...props} />;
  }

  return <LinkComponent to={to} />;
};

LinkRoute.propTypes = {
  component: PropTypes.any,
  to: PropTypes.string,
};
